import axios from '~/helpers/orchestration/axiosWithAuthHandling';
import { orchestration } from '~/config/public';
import { getDefaultHeaders } from '~/helpers/orchestration/shared';
import { CarGuideAnswers, CarGuideResults } from '~/App/views/Carguide/types';
import { isAxiosError } from '../axiosUtils';
import { logger } from '~/helpers/logger';

interface GetCarGuideResultsParams {
  answers: Partial<CarGuideAnswers>;
  limit: number;
}

export interface GetCarGuideResultsResponse {
  data: { carGuide: CarGuideResults['data'] };
  status: number;
}

export const getCarguideResults = async ({
  answers,
  limit
}: GetCarGuideResultsParams) => {
  try {
    const { data, status } = await axios.post<GetCarGuideResultsResponse>(
      `${orchestration.url}/auction/car-guide`,
      { answers, limit },
      {
        responseType: 'json',
        headers: await getDefaultHeaders()
      }
    );

    return {
      data,
      status
    };
  } catch (err) {
    logger.error(err.message, { error: err });

    if (isAxiosError(err)) {
      return { ...err.response };
    }

    return err;
  }
};

interface SaveMemberAnswersArgs {
  answers: Partial<CarGuideAnswers>;
  idToken: string;
}

export const saveMemberAnswers = async ({
  answers,
  idToken: _idToken
}: SaveMemberAnswersArgs) => {
  try {
    const { data, status } = await axios.put<{
      memberAnswers: CarGuideAnswers;
    }>(`${orchestration.url}/auction/carguide_answers`, answers, {
      responseType: 'json',
      headers: await getDefaultHeaders()
    });
    return {
      data,
      status
    };
  } catch (err) {
    logger.error(err.message, { error: err });

    if (isAxiosError(err)) {
      return { ...err.response };
    }

    return err;
  }
};
